import gql from 'graphql-tag';

export class TemplateGalleryQueries {
  static loadGlobalTemplatesQuery = gql`
    query GlobalResources(
      $searchTerms: [String!]!
      $limit: Int!
      $offset: Int!
      $sortBy: ResourceSortAttributes!
      $sortOrder: String!
    ) {
      globalResources(
        searchTerms: $searchTerms
        limit: $limit
        offset: $offset
        sortBy: $sortBy
        sortOrder: $sortOrder
      ) {
        resources {
          id
          blockId
          contentId
          title
          resourceType
        }
      }
    }
  `;

  static loadGlobalTemplate = gql`
    query GlobalDocument($documentId: String!) {
      globalDocument(documentId: $documentId) {
        id
        previewThumbUrl
        name
      }
    }
  `;
}
